import { FC } from 'react';
import { DecrementIncrementButton } from 'components';
import DisplayOrderToolTip from '../components/DisplayOrderToolTip';

interface DisplayTagOrderProps {
  displayOrder: string;
  setDisplayOrder: (value: string) => void;
}

const DisplayTagOrder: FC<DisplayTagOrderProps> = ({ displayOrder, setDisplayOrder }) => {
  return (
    <div className="z-30 flex flex-col gap-2">
      <label className="flex items-center gap-2 text-17px font-semibold text-headingGray">
        Display order
        <DisplayOrderToolTip />
      </label>
      <DecrementIncrementButton
        className="w-[200px]"
        changeValueBy={1}
        setValueCallback={value => setDisplayOrder(value)}
        overridingValue={displayOrder}
        placeholder="1"
        showDecimals={false}
      />
    </div>
  );
};

export default DisplayTagOrder;
